<template>
  <div class="main-page-modal-content">
    <div class="main-page-modal-content__head">
      <div class="main-page-modal-content__sort">
        <div>
          <h4 class="main-page-modal-content__sort-header">{{ $t('SORT_BY') }}:</h4>
          <a-radio-group
              :value="activeSort"
              @change="handleSortChange"
              class="main-page-modal-content__sort-buttons">
            <a-radio-button
                v-for="(sort, i) in listSort"
                :key="i"
                :value="sort.value"
                @click="sort.value === 'likes.length' ? sortByPopular() : sortByField('name')"
                class="main-page-modal-content__sort-button">
              {{ $t(sort.label) }}
              <a-icon
                  class="main-page-modal-content__sort-button-caret"
                  :type="listSortType === 'desc' ? 'caret-up' : 'caret-down'"
                  theme="filled"/>
            </a-radio-button>
            <!--todo Сделать вкл/выкл иконкой-->
          </a-radio-group>
        </div>
        <a-row class="main-page-modal-content__sort_gallery-button">
          <span @click="showGallery"><span v-if="notGallery"><a-icon type="picture"/></span><span v-else><a-icon
              type="profile"/></span></span>
        </a-row>
      </div>
    </div>
    <a-list
        class="main-page-modal-content__list"
        :itemLayout="listType"
        size="large"
        :pagination="false"
        :dataSource="cemeteriesList">
      <!--      Я заменил строку так как нужно сделать фильтр кладбищ-->
      <!--todo Вынести в отдельный компонент-->
      <a-list-item
          style="position: relative"
          class='main-page-modal-content__item'
          slot="renderItem"
          slot-scope="item"
          :class="{'main-page-content__item_full': !notGallery}"
          key="item.id"
          @click="openCementeryModal(item.id)">
        <img
            :class="{'ant-list-objectFit': listType === 'horizontal'}"
            v-if="item.cemetary_photo && item.cemetary_photo.attachment"
            slot="extra"
            :height="listType === 'vertical' ? '150' : ''"
            :src="'https://api.oooak.org/'+ item.cemetary_photo.attachment.medium.url"/>
        <img
            :class="{'ant-list-objectFit': listType === 'horizontal'}"
            v-if="item.cemetary_photo == null"
            slot="extra"
            :height="listType === 'vertical' ? '150' : ''"
            class='main-page-modal-content__img-empty'
            src="@/assets/img/cemetery.svg"/>
        <div class="main-page-modal-content__info" v-if="notGallery">
          <div class="main-page-modal-content__title" v-if="listType === 'vertical'">
            <strong v-if="item.name">{{ item.name }}</strong>
            <strong v-else>{{ $t('UNKNOWN_CEMETERY_NAME') }}</strong>
          </div>
          <div v-if="listType === 'vertical'">
            <strong>{{ $t('CEMETARY_LOCATION') }}: </strong>
            <span v-if="item.country || item.city">{{ item.country }}, {{ item.city }}</span>
            <span v-else>{{ $t('UNKNOWN') }}</span>
          </div>
          <div v-if="listType === 'vertical'">
            <strong>{{ $t('CATEGORIES') }}: </strong>
            <div v-if="item.categories.length" class="main-page-content__categories">
              <span v-for="(category, key) in item.categories" :key="key">{{ category.name }}</span>
            </div>
            <span v-else>{{ $t('UNKNOWN') }}</span>
          </div>
        </div>
        <template slot="actions">
          <span @click.stop="deleteLike(item, user)" :class="{'changePosition': listType === 'horizontal'}">
            {{ item.likes.length }}
            <a-icon
                type="heart"
                style="margin-right: 8px;"
                :theme="item.likes.find(x => x.user_id == user.id) ? 'filled' : 'outlined'"/>
          </span>
        </template>
      </a-list-item>
    </a-list>

    <!--Модальное окно кладбищ-->
    <cemeteries-modal/>
  </div>
</template>

<script>
import BaseComponent from "@/components/extends/BaseComponent";
import cemeteryModal from "@/components/cemetaries/item/modal";
import {mapActions, mapGetters} from "vuex";
import {paramInURLToggle} from "@/services/http";

export default {
name: "CemeteryListContent",
  extends: BaseComponent,
  components: {
    [cemeteryModal.name]: cemeteryModal,
  },
  data() {
    return {
      listOptions: {
        offset: 0,
        page: 1,
        per_page: 20,
        selected_sort: 'likes.length'
      },
      listSort: [
        {
          label: 'POPULARITY',
          value: 'likes.length'
        },
        {
          label: 'ALPHABET',
          value: 'first_name'
        },
      ],
      activeSort: '',
      listSortType: 'asc',
      listData: [],
      listType: 'vertical',
    };
  },
  computed: {
    ...mapGetters({
      notGallery: 'cemeteries/getGallery',
      cemeteriesList: 'cemeteries/getCemeteriesList',
      isAuth: 'user/isAuth',
      filteredCemeteriesList: 'cemeteries/getFilteredCemeteriesList',
      filterCategoriesIds: 'categories/getSelectedIds',
      isShowCemeteriesModal: 'cemeteries/isShowModal',
      user: 'user/getUser',
    }),
  },
  methods: {
    ...mapActions({
      like: 'cemeteries/cemeteryLike',
      initCemeteriesList: 'cemeteries/getCemeteriesList',
      deleteCemeteryLike: 'cemeteries/deleteCemeteryLike',
      showGallery: 'cemeteries/showGallery',
      getCurrentCemetery: 'cemeteries/getCurrentCemetery',
      layoutActive: 'modal/layoutActive'
    }),

    async init() {
      this.cemeteries = this.cemeteriesList;
    },

    deleteLike(item, user) {
      let userLike =  item.likes.find(x => x.user_id == user.id)
      if (userLike){
        this.deleteCemeteryLike(userLike)
      } else {
        this.cemeteryLike(item.id)
      }
    },

    cemeteryLike(cemeteryId) {
      if (this.isAuth) {
        this.like({
          user_id: this.user.id,
          post_entity_id: cemeteryId,
          post_entity_type: "Cemetary"
        })
      } else {
        this.authModalToggle(this.$t('SIGN_IN_TO_LIKE'))
      }
    },
    sortByPopular() {
      this.$store.commit('cemeteries/SORT_CEMETERIES_BY_POPULARITY', this.listSortType);
      this.listSortTypeToggle();
    },
    sortByField(fieldName) {
      this.$store.commit('cemeteries/SORT_CEMETERIES_BY_FIELD', {
        fieldName: fieldName,
        sortType: this.listSortType,
      });
      this.listSortTypeToggle();
    },
    listSortTypeToggle() {
      this.listSortType === 'asc' ? this.listSortType = 'desc' : this.listSortType = 'asc';
    },
    listTypeToggle() {
      this.listType === 'horizontal' ? this.listType = 'vertical' : this.listType = 'horizontal';
    },

    async openCementeryModal(cementeryId) {
      await this.getCurrentCemetery(cementeryId)
      paramInURLToggle('id', cementeryId);
    },

    handleSortChange(e) {
      this.activeSort = e.target.value;
    }
  },
}
</script>

<style lang="scss" scoped>
.main-page-modal-content {
  .ant-list-item {
    margin-right: 0;
  }
  &__sort {
    position: relative;
    display: flex;
    padding: 20px 10px 5px;
    &_gallery-button {
      position: absolute;
      z-index: 71;
      bottom: 0;
      right: 10px;
      font-size: 25px;
      color: #A3A3A3;
    }
  }
  .ant-list-item-extra {
    & img {
      max-height: none;
      max-width: none;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
